import React from 'react';
import AdicionarDocumentoDialog from '../../../components/documentos/AdicionarDocumentoDialog';

export default function AdicionarContratoPlano(props) {
    return (
        <AdicionarDocumentoDialog
            open={props.adicionarContrato}
            onClose={() => props.setAdicionarContrato(false)}
            endpoint="adicionarContratoPlano"
            title="Nova versão do Contrato de Plano"
            description="O conteúdo publicado passa a valer como a versão mais recente do contrato."
            placeholder="Digite o contrato de plano aqui..."
        />
    );
}
